import { RootState } from 'app/store';

const inst = (state: RootState, contextKey = 'main') =>
  state.userDetail.instances?.[contextKey] ?? state.userDetail.instances?.main;

export const selectUserData = (state: RootState, contextKey = 'main') => inst(state, contextKey).userData.data;

export const selectUserDataNotFound = (state: RootState, contextKey = 'main') =>
  inst(state, contextKey).userData.status === 'notFound';

export const selectUserHistoric = (state: RootState, contextKey = 'main') => inst(state, contextKey).userHistoric.data;

export const selectUserDetailLastLocation = (state: RootState, contextKey = 'main') => inst(state, contextKey).userData.lastLocation;

export const selectUserDetailMeasures = (state: RootState, contextKey = 'main') => inst(state, contextKey).measures.data;

export const selectRelations = (state: RootState, contextKey = 'main') => inst(state, contextKey).relatives.data;

export const selectRelativesPagination = (state: RootState, contextKey = 'main') => inst(state, contextKey).relatives.pagination;

export const selectNotifications = (state: RootState, contextKey = 'main') => inst(state, contextKey).notifications.data;

export const selectNotificationsPagination = (state: RootState, contextKey = 'main') => inst(state, contextKey).notifications.pagination;

export const selectActions = (state: RootState, contextKey = 'main') => inst(state, contextKey).actions.data;

export const selectActionsPagination = (state: RootState, contextKey = 'main') => inst(state, contextKey).actions.pagination;

export const selectHistoricServiceState = (state: RootState, contextKey = 'main') => inst(state, contextKey).historicServiceState.data;

export const selectServicesState = (state: RootState, contextKey = 'main') => inst(state, contextKey).servicesState.data;

export const selectPatientServicesStateOptions = (state: RootState, contextKey = 'main') => inst(state, contextKey).listServicesOptionsState.data;

export const selectPatientServiceTypeOptions = (state: RootState, contextKey = 'main') => inst(state, contextKey).listServicesTypeOptions.data;
export const selectPatientServiceExpiration = (state: RootState, contextKey = 'main') => inst(state, contextKey).serviceExpiration.data;
export const selectPatientServiceExpirationStatus = (state: RootState, contextKey = 'main') => inst(state, contextKey).serviceExpiration.status;

export const selectServiceConfiguration = (state: RootState, contextKey = 'main') => inst(state, contextKey).serviceConfiguration.data;

export const selectServiceContactWay = (state: RootState, contextKey = 'main') => inst(state, contextKey).serviceContactWay.data;

export const selectHistoricServiceStatePagination = (state: RootState, contextKey = 'main') => inst(state, contextKey).historicServiceState.pagination;

export const selectTermsAndConditionsAgreement = (state: RootState, contextKey = 'main') => inst(state, contextKey).termsAndConditionsAgreement.data;

export const selectTermsAndConditionsAgreementPagination = (state: RootState, contextKey = 'main') => inst(state, contextKey).termsAndConditionsAgreement.pagination;

export const selectPatientNotes = (state: RootState, contextKey = 'main') => inst(state, contextKey).notes.data;

export const selectPatientNotesPagination = (state: RootState, contextKey = 'main') => inst(state, contextKey).notes.pagination;

export const selectPatientsNotesAllTypes = (state: RootState, contextKey = 'main') => inst(state, contextKey).notesAllTypes.data;

export const selectPatientsNotesAllTypesPagination = (state: RootState, contextKey = 'main') => inst(state, contextKey).notesAllTypes.pagination;

export const selectPatientActiveAgenda = (state: RootState, contextKey = 'main') => inst(state, contextKey).activeAgenda.data;

export const selectPatientFinishedAgenda = (state: RootState, contextKey = 'main') => inst(state, contextKey).finishedAgenda.data;

//export const selectTotalPatientAgenda = (state: RootState, contextKey = 'main') => inst(state, contextKey).agenda.pagination;

export const selectPatientAgendaSelected = (state: RootState, contextKey = 'main') => inst(state, contextKey).agendaSelected;

export const selectPatientAgendaMode = (state: RootState, contextKey = 'main') => inst(state, contextKey).activeAgenda.mode;

export const selectMeasuresGenericTypesData = (state: RootState, contextKey = 'main') => inst(state, contextKey).measuresByType.data;

// Stable fallback so components can depend on the selector result identity.
const NO_REQUESTS = {};
export const selectMeasuresByTypeRequests = (state: RootState, contextKey = 'main') =>
  inst(state, contextKey).measuresByType.requests ?? NO_REQUESTS;

export const selectEffectiveMeasureRulesState = (state: RootState, contextKey = 'main') =>
  inst(state, contextKey).effectiveMeasureRules;

export const selectVideoCall = (state: RootState, contextKey = 'main') => inst(state, contextKey).videoCall.uri;

export const selectReport = (state: RootState, contextKey = 'main') => inst(state, contextKey).report;

export const selectResolutionSelected = (state: RootState, contextKey = 'main') => inst(state, contextKey).resolutionSelected;


export const selectOpenModalResolution = (state: RootState, contextKey = 'main') => inst(state, contextKey).openModalResolution;

export const selectOpenModalMeasureFile = (state: RootState, contextKey = 'main') => inst(state, contextKey).openModalMeasureFile;

export const selectHealthData = (state: RootState, contextKey = 'main') => inst(state, contextKey).healthData.data;

export const selectPersonalData = (state: RootState, contextKey = 'main') => inst(state, contextKey).personalData.data;

export const selectHealthInsurance = (state: RootState, contextKey = 'main') => inst(state, contextKey).healthInsurance.data;

export const selectHealthService = (state: RootState, contextKey = 'main') => inst(state, contextKey).healthService.data;

export const selectHealthdataPathologies = (state: RootState, contextKey = 'main') => inst(state, contextKey).healthData.data.pathologies;

export const selectHealthdataInterventions = (state: RootState, contextKey = 'main') => inst(state, contextKey).healthData.data.interventions;

export const selectHealthdataAllergies = (state: RootState, contextKey = 'main') => inst(state, contextKey).healthData.data.allergies;

export const selectHealthdataMedications = (state: RootState, contextKey = 'main') => inst(state, contextKey).healthData.data.medications;

export const selectHealthdataSituations = (state: RootState, contextKey = 'main') => inst(state, contextKey).healthData.data.situations;

export const selectHealthdataVaccines = (state: RootState, contextKey = 'main') => inst(state, contextKey).healthData.data.vaccines;

export const selectHealthDataEditMode = (state: RootState, contextKey = 'main') => inst(state, contextKey).editHealthData;

export const selectPersonalInfoPets = (state: RootState, contextKey = 'main') => inst(state, contextKey).personalInfo.data.environmentpets

export const selectPersonalInfoServices = (state: RootState, contextKey = 'main') => inst(state, contextKey).personalInfo.data.environmentservices

export const selectPersonalInfoSocial = (state: RootState, contextKey = 'main') => inst(state, contextKey).personalInfo.data.social

export const selectPersonalInfoPersonalContacts = (state: RootState, contextKey = 'main') => inst(state, contextKey).personalInfo.data.personalcontacts

export const selectPersonalInfoGeneralContacts = (state: RootState, contextKey = 'main') => inst(state, contextKey).personalInfo.data.generalcontacts

export const selectCreatedNewPatient = (state: RootState, contextKey = 'main') => inst(state, contextKey).newPatient;

export const selectAddedPatient = (state: RootState, contextKey = 'main') => inst(state, contextKey).addPatient;

export const selectUpdatedPatient = (state: RootState, contextKey = 'main') => inst(state, contextKey).updatePatient;

export const selectCreatedServiceConfiguration = (state: RootState, contextKey = 'main') => inst(state, contextKey).serviceConfiguration.newServiceConfiguration;

export const selectPatientRules = (state: RootState, contextKey = 'main') => inst(state, contextKey).rules.data;

export const selectRulesCreated = (state: RootState, contextKey = 'main') => inst(state, contextKey).rulesCreatedState;

export const selectRulesDeleted = (state: RootState, contextKey = 'main') => inst(state, contextKey).rulesDeletedState;

export const selectRulePatientSelected = (state: RootState, contextKey = 'main') => inst(state, contextKey).ruleSelected;

export const selectOpenRuleSelected = (state: RootState, contextKey = 'main') => inst(state, contextKey).openRuleSelected;

export const selectTabSelected = (state : RootState, contextKey = 'main') => inst(state, contextKey).tabSelected;

export const selectUserCreatedId = (state : RootState, contextKey = 'main') => inst(state, contextKey).userCreatedId;


export const selectUnreadNotificationsCount = (state : RootState, contextKey = 'main') => inst(state, contextKey)?.unreadNotifications?.data;
export const selectUnreadNotificationsStatus = (state: RootState, contextKey = 'main') => inst(state, contextKey)?.unreadNotifications?.status ?? 'idle';

export const selectOpenModalNotificationShow = (state : RootState, contextKey = 'main') => inst(state, contextKey).openModalNotificationShow;

export const selectOpenModalNotificationSend = (state : RootState, contextKey = 'main') => inst(state, contextKey).openModalNotificationSend;

export const selectOpenModalNotificationEdit = (state : RootState, contextKey = 'main') => inst(state, contextKey).openModalNotificationEdit;

export const selectOpenAgendaModal = (state : RootState, contextKey = 'main') => inst(state, contextKey).openAgendaModal;

export const selectOpenNoteModal = (state : RootState, contextKey = 'main') => inst(state, contextKey).openNoteModal;

export const selectHistoricServiceStateSelected = (state : RootState, contextKey = 'main') => inst(state, contextKey).historicServiceStateSelected;

export const selectHistoricUserDevicesData = (state: RootState, contextKey = 'main') => inst(state, contextKey).historicDevices.data;

export const selectHistoricUserDevicesPagination = (state: RootState, contextKey = 'main') => inst(state, contextKey).historicDevices.pagination;

export const selectPutServicesState = (state: RootState, contextKey = 'main') => inst(state, contextKey).putServicesState.data;

export const selectPostServicesState = (state: RootState, contextKey = 'main') => inst(state, contextKey).postServicesState.data;


export const selectOptionsEventType = (state: RootState, contextKey = 'main') => inst(state, contextKey).actions.filterableValues?.eventType;

export const selectOptionsEventState = (state: RootState, contextKey = 'main') => inst(state, contextKey).actions.filterableValues?.eventState;

export const selectOptionsEventHasResolution = (state: RootState, contextKey = 'main') => inst(state, contextKey).actions.filterableValues?.eventHasResolution;

export const selectOptionsPatientGroup = (state: RootState, contextKey = 'main') => inst(state, contextKey).actions.filterableValues?.patientGroup;

export const selectOptionsDeviceTypeCode = (state: RootState, contextKey = 'main') => inst(state, contextKey).actions.filterableValues?.deviceTypeCode;

export const selectOptionsDevicePeripheralTypeCode = (state: RootState, contextKey = 'main') => inst(state, contextKey).actions.filterableValues?.peripheralTypeCode;

export const selectOptionsEventResolved = (state: RootState, contextKey = 'main') => inst(state, contextKey).actions.filterableValues?.eventResolved;

export const selectOptionsStatus = (state: RootState, contextKey = 'main') => inst(state, contextKey).actions.filterableValues;
/** true mientras la lista `key` de la instancia (relatives, notes, actions, historicDevices...) está cargando. */
export const selectInstanceLoading = (state: RootState, contextKey = 'main', key: string): boolean =>
  (inst(state, contextKey) as any)?.[key]?.status === 'loading';

/** true mientras se pide la ruta de salud `path` (pathologies, allergies, medications, vaccines, situations...). */
export const selectHealthDataLoading = (state: RootState, contextKey = 'main', path: string): boolean =>
  inst(state, contextKey)?.healthData?.loading?.[path] === true;

/** true mientras se pide la ruta de información personal `path` (admite la forma con guiones: personal-contacts). */
export const selectPersonalInfoLoading = (state: RootState, contextKey = 'main', path: string): boolean =>
  inst(state, contextKey)?.personalInfo?.loading?.[path.split('-').join('')] === true;

export const selectHealthServiceLoading = (state: RootState, contextKey = 'main'): boolean =>
  inst(state, contextKey)?.healthService?.status === 'loading';

/** Mapa ruta → en vuelo de los datos de salud, para pintar varias tablas de una vez (Resumen). */
export const selectHealthDataLoadingMap = (state: RootState, contextKey = 'main'): Record<string, boolean> =>
  inst(state, contextKey)?.healthData?.loading ?? {};
